export const SCOPE = {
    AMZL: "AMZL",
    AR: "AR",
    SSD: "SSD",
    AR_NEXT_GEN: "AR_NEXT_GEN",
    AMZL_IN: "AMZL_IN"
}
